<div class="tw-mx-[10px] tw-my-[30px] tw-flex tw-items-center">
  <div class="tw-flex-1">
    <ate-button-control class="tw-w-fit tw-min-w-0 tw-p-3" (click)="navigateBack()" color="secondary"
      ><ate-icon name="chevron-left-v2"></ate-icon>
      <span class="tw-hidden md:tw-block">{{ backButtonText }}</span>
    </ate-button-control>
  </div>

  <h2>Edit Customer</h2>
  <div class="tw-flex-1"></div>
</div>
<section
  class="tw-block tw-border-b tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-slate-200 tw-bg-white md:tw-mx-[10px] md:tw-mx-[10px] md:tw-rounded-[5px] md:tw-border-l md:tw-border-r">
  <div class="tw-relative tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-5 tw-py-5 tw-text-gray-800 md:tw-px-10">
    <h2>Customer Details</h2>
    <p class="!tw-mb-0 tw-mt-[15px]">Edit the customer information below.</p>
  </div>

  <customer-form-component
    (formCancel)="navigateBack()"
    (formSubmit)="updateCustomer($event)"
    [customerUuid]="customerUuid"></customer-form-component>
</section>
